// Sub-rutas del área de personal autorizado de la empresa (detalle)
// Se comparten entre la tabla (botón Entrar) y el layout de detalle para
// mantener las URLs centralizadas.
export const EMPRESA_DETALLE_PATHS = {
    INICI: '/inici',
    FACTURAS: '/factures',
    MIS_ACTIVIDADES: '/mis-activitats',
    PERSONAS: '/persones',
    CATALOGO_CURSOS: '/cataleg-cursos',
    MIS_DATOS: '/mis-dades',
}